<template>
  <form
    ref="form"
    method="post"
    @submit.prevent="onSubmit"
    :id="formId"
    :class="['form', formClasses, { 'is-sending': isFormSending, 'is-success': isFormSent }]"
    :data-type="form.type"
    novalidate
  >
    <div v-html="xsrfFormHtml"></div>

    <div v-if="eventHasSwitcher" class="form__row form__row--switcher">
      <div class="radio-switcher js-radio-switcher" ref="radioSwitcher">
        <label>
          <input type="radio" name="event_type" value="offline" @change="onEventTypeChange" checked="checked" />
          <span>Офлайн</span>
        </label>
        <label>
          <input type="radio" name="event_type" @change="onEventTypeChange" value="online" />
          <span>Онлайн</span>
        </label>
        <span class="radio-switcher__caret js-radio-switcher-caret"></span>
      </div>
    </div>

    <div v-if="eventHasSwitcher" class="form__row form__row--caption">
      <p v-if="eventType === 'offline'">
        Пожалуйста, обязательно заполните все поля формы регистрации корректно, чтобы мы&nbsp;быстрее подготовили для вас бейдж
      </p>
    </div>

    <div class="form__row" v-if="showThisField('name')">
      <base-input type="text" class="input" ref="name" name="name" placeholder="Имя" v-model="form.name" required />
    </div>

    <div class="form__row" v-if="showThisField('last_name')">
      <base-input
        type="text"
        class="input"
        ref="last_name"
        name="last_name"
        placeholder="Фамилия"
        v-model="form.last_name"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('phone')">
      <base-input
        v-model="form.phone"
        type="tel"
        class="input"
        ref="phone"
        name="phone"
        placeholder="Телефон"
        maxlength="25"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('email')">
      <base-input
        v-model="form.email"
        type="email"
        class="input"
        ref="email"
        name="email"
        placeholder="Эл. почта"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('position')">
      <base-input
        v-model="form.position"
        type="text"
        class="input"
        ref="position"
        name="position"
        placeholder="Должность"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('company')">
      <base-input
        v-model="form.company"
        type="text"
        class="input"
        ref="company"
        name="company"
        placeholder="Компания"
        minlength="2"
        required
      />
    </div>

    <div class="form__row form__row--hint" v-if="showThisField('ten_years_hf_id')">
      <base-input
        v-model="form.ten_years_hf_id"
        type="text"
        class="input"
        ref="ten_years_hf_id"
        name="ten_years_hf_id"
        placeholder="ID компании в Хантфлоу"
        required
      />
      <div
      class="hint"
      :class="{ 'hint--hidden': form.ten_years_hf_id }"
      >
        <div class="hint__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <circle opacity="0.2" cx="10.5" cy="10.9297" r="10" fill="white"/>
            <path d="M10.8195 6.16016C11.5208 6.16016 12.1052 6.26787 12.5727 6.48328C13.0402 6.69412 13.3908 6.97599 13.6245 7.32891C13.8629 7.67724 13.982 8.05536 13.982 8.46328C13.982 8.90787 13.8949 9.27224 13.7208 9.55641C13.5512 9.83599 13.3404 10.072 13.0883 10.2645C12.8362 10.4524 12.5818 10.6289 12.3252 10.7939C12.0731 10.9589 11.8599 11.1445 11.6858 11.3508C11.5162 11.557 11.4314 11.8206 11.4314 12.1414V12.4233H9.44453V12.0727C9.44453 11.6006 9.52016 11.2156 9.67141 10.9177C9.82724 10.6152 10.0174 10.3677 10.242 10.1752C10.4712 9.98266 10.6981 9.81537 10.9227 9.67328C11.1472 9.52662 11.3352 9.37766 11.4864 9.22641C11.6422 9.07057 11.7202 8.87807 11.7202 8.64891C11.7202 8.39682 11.617 8.20432 11.4108 8.07141C11.2045 7.93849 10.941 7.87203 10.6202 7.87203C10.3085 7.87203 10.0037 7.94078 9.70578 8.07828C9.41245 8.21578 9.14203 8.42661 8.89453 8.71078L7.51953 7.63828C7.9137 7.17537 8.3812 6.81328 8.92203 6.55203C9.46745 6.29078 10.0999 6.16016 10.8195 6.16016ZM10.462 13.6745C10.8058 13.6745 11.0991 13.7983 11.342 14.0458C11.5849 14.2887 11.7064 14.5797 11.7064 14.9189C11.7064 15.2581 11.5849 15.5514 11.342 15.7989C11.0991 16.0418 10.8058 16.1633 10.462 16.1633C10.1137 16.1633 9.82036 16.0418 9.58203 15.7989C9.3437 15.5514 9.22453 15.2581 9.22453 14.9189C9.22453 14.5797 9.3437 14.2887 9.58203 14.0458C9.82036 13.7983 10.1137 13.6745 10.462 13.6745Z" fill="white"/>
          </svg>
        </div>
        <div class="hint__content">
          <h3>Как найти&nbsp;ID компании в&nbsp;Хантфлоу</h3>
          <p>Перейдите в&nbsp;свой Хантфлоу и&nbsp;кликните на&nbsp;шестеренку вверху экрана. ID&nbsp;будет указан под названием компании. Нажмите на&nbsp;него, и&nbsp;он&nbsp;скопируется в&nbsp;буфер обмена</p>
            <picture>
                <source type="image/webp"
                      srcset="/static/promo-static/landing-2021/src/images/pages/ten-years/event/hint/hint.webp 1x,
                      /static/promo-static/landing-2021/src/images/pages/ten-years/event/hint/hint@2x.webp 2x"
                >
                <img src="/static/promo-static/landing-2021/src/images/pages/ten-years/event/hint/hint@2x.jpg" alt="Хантфлоу AI" class="ai-icon">
            </picture>
        </div>
      </div>
    </div>

    <div class="form__row" v-if="showThisField('client_status')">
      <label class="checkbox">
        <input type="checkbox" v-model="form.client_status" ref="client_status" name="client_status" />
        <span class="checkmark"></span>
        Я&nbsp;&mdash; клиент Хантфлоу
      </label>
    </div>

    <span class="error-message" v-if="isSubmittedError">
      Ошибка отправки данных.<br />
      Пожалуйста, попробуйте еще раз.
    </span>

    <base-button
      type="submit"
      class="form__submit button button--block button--xl button--primary"
      :data-event="form.type"
      >{{ formTextButton }}</base-button
    >

    <div class="container" v-if="!isObjectEmpty(formSuccessMessageProps)">
      <div class="form-success">
        <FormSuccessMessage
          ref="formSuccessMessage"
          :title="formSuccessMessageProps.title"
          :caption="formSuccessMessageProps.caption"
          :form-type="formSuccessMessageProps.formType"
          :telegram-info="formSuccessMessageProps.telegramInfo"
          :telegram-link="telegramLink"
        />
      </div>
    </div>
  </form>
</template>

<script>
import { BaseInput, BaseButton } from 'huntkit';
import 'huntkit/hunt-kit.css';
import FormUtils from './FormUtils.js';
import FormSuccessMessage from '~scripts/blocks/vue/FormSuccessMessage.vue';
import { handleRadioSwitcherInit } from '~scripts/components/forms/radios';

function roistatDataCommon() {
  return [
    {
      name: 'Регистрации на Event',
      visit: roistat.visit,
    },
  ];
}

export default {
  name: 'ParticipateForm',
  components: {
    FormSuccessMessage,
    BaseInput,
    BaseButton,
  },
  props: {
    formHasSwitcher: {
      type: Boolean,
      default: false,
    },
    eventTypeCustom: String,
    formClasses: String,
    formId: String,
    formTextButton: String,
    formEventGa: String,
    formEventYm: String,
    formEventRoistatOffline: String,
    formEventRoistatOnline: String,
    fieldNames: String,
    telegramLink: String,
    formSuccessMessageProps: {
      type: Object,
      default: null,
    },
    xsrfToken: String,
  },
  data() {
    return {
      eventType: undefined,
      form: {
        _xsrf: this.xsrfToken,
        type: this.formEventGa,
      },
      isSubmittedError: false,
      isFormSent: false,
      isFormSending: false,
    };
  },
  watch: {
    'form.client_status': function (newVal) {
      this.form.client_status = newVal ? 'on' : '';
    },
  },
  computed: {
    formBlock() {
      return this.$refs?.form.closest('.form-block');
    },
    xsrfFormHtml() {
      return FormUtils.xsrfFormHtml(this.xsrfToken);
    },
    pathname() {
      return window.location.pathname;
    },
    eventHasSwitcher() {
      return this.formHasSwitcher;
    },
  },
  mounted() {
    this.form = FormUtils.createFormData(this.fieldNames, this.form);

    if (this.eventHasSwitcher) {
      this.setEventTypeInitial();
      handleRadioSwitcherInit(this.$refs.radioSwitcher);
      window.addEventListener('resize', this.handleResize);
    }
  },
  beforeDestroy() {
    if (this.eventHasSwitcher) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  methods: {
    showThisField(name) {
      const fieldNames = this.fieldNames.split(',');
      return fieldNames.includes(name);
    },

    findEmptyField() {
      const excludedFields = ['_xsrf', 'type', 'roistat', 'client_status'];
      return FormUtils.findEmptyField(this.form, excludedFields, this.$refs);
    },

    isObjectEmpty(obj) {
      return Object.keys(obj).length === 0;
    },

    setEventTypeInitial() {
      if (this.eventHasSwitcher) {
        this.eventType = 'offline';
        this.form.type = `${this.formEventGa}-offline`;
      }
    },

    onEventTypeChange(e) {
      this.eventType = e.target.value;
      this.form.type = `${this.formEventGa}-${this.eventType}`;
    },

    redirect() {
      FormUtils.redirectToThankYouPage();
    },

    handleResize() {
      handleRadioSwitcherInit(this.$refs.radioSwitcher);
    },

    handleError() {
      this.isFormSending = false;
      this.isSubmittedError = true;
    },

    async handleSuccess() {
      if (this.formBlock) {
        this.formBlock.classList.add('is-success');
      }

      // Сommon events
      window.submitEventForm();

      const roistatData = roistatDataCommon();

      // Custom events
      if (this.eventHasSwitcher) {
        const { eventType } = this;

        this.form.type = `${this.formEventGa}-${eventType}`;

        // Яндекс Метрика
        const eventYm = this.formEventYm;
        if (eventYm) {
          window.submitEventFormCustom({ ym: `${eventYm}-${eventType}` });
        }

        // Roistat
        const eventRoistatOnline = this.formEventRoistatOnline;
        if (eventType === 'online' && eventRoistatOnline) {
          roistatData.push({
            name: eventRoistatOnline,
            visit: roistat.visit,
          });
        }

        const eventRoistatOffline = this.formEventRoistatOffline;
        if (eventType === 'offline' && eventRoistatOffline) {
          roistatData.push({
            name: eventRoistatOffline,
            visit: roistat.visit,
          });
        }
      }

      // Roistat
      await fetch('/events/roistat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(roistatData),
      });

      if (this.eventTypeCustom === 'premier') {
        this.$refs.formSuccessMessage.show();
        return;
      }

      this.isFormSending = false;
      this.isFormSent = true;

      this.redirect();
    },

    onSubmit(e) {
      e.preventDefault();

      if (!this.findEmptyField()) {
        this.submitForm();
      }
    },

    submitForm() {
      this.isFormSending = true;

      FormUtils.submitForm('/subscribe', this.form, this.handleSuccess.bind(this), this.handleError.bind(this));
    },
  },
};
</script>

<style scoped lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.input {
  border: initial;
}

.input,
.button {
  height: initial;
}
.error-message {
  @include mixins.font(1.5rem, 1.55);

  display: inline-block;
  margin-bottom: 1.2rem;
  color: #ff5b5b;

  @include mixins.media(md) {
    @include mixins.font(1.9rem, 1.45);
  }
}
</style>
